/**
 * Groups course tests by tab (block) label. Blank or whitespace-only tab names are ignored;
 * duplicate tab labels per test are deduped; tests with no valid tab go under "Sin asignar".
 * @param {object[] | null | undefined} tests
 * @param {string[] | null | undefined} pestanasCurso
 * @returns {{ porBloque: Record<string, Array<{ test: object, index: number }>>, bloquesOrdenados: string[] }}
 */
export function groupCourseTestsByTab(tests, pestanasCurso) {
  const list = Array.isArray(tests) ? tests : [];
  const pestanasList = Array.isArray(pestanasCurso) ? pestanasCurso : [];
  const porBloque = {};
  list.forEach((t, idx) => {
    if (t === null || typeof t !== "object") {
      return;
    }
    let pestanasRaw;
    if (Array.isArray(t.pestanas)) {
      pestanasRaw = t.pestanas;
    } else if (t.pestanas) {
      pestanasRaw = [t.pestanas];
    } else {
      pestanasRaw = [];
    }
    const trimmedPestanas = [
      ...new Set(pestanasRaw.map((b) => (typeof b === "string" ? b.trim() : "")).filter(Boolean)),
    ];
    trimmedPestanas.forEach((b) => {
      if (!porBloque[b]) {
        porBloque[b] = [];
      }
      porBloque[b].push({ test: t, index: idx });
    });
    if (trimmedPestanas.length === 0) {
      if (!porBloque["Sin asignar"]) {
        porBloque["Sin asignar"] = [];
      }
      porBloque["Sin asignar"].push({ test: t, index: idx });
    }
  });
  const bloquesOrdenados = [
    ...new Set(
      [...pestanasList, ...Object.keys(porBloque).filter((k) => k !== "Sin asignar"), "Sin asignar"].filter(Boolean),
    ),
  ];
  return { porBloque, bloquesOrdenados };
}
